(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-gifts/assets/javascripts/redeem/components/game-launcher-wrapper.js') >= 0) return;  svs.modules.push('/modules/ticket-gifts/assets/javascripts/redeem/components/game-launcher-wrapper.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const PlayFooter = svs.ticket_gifts.redeem.components.PlayFooter;
const useCustomEvents = svs.ticket_gifts.redeem.components.useCustomEvents;
const BubbleWinMessage = svs.tur.bubbleWinMessage.components.BubbleWinMessage;
const _svs$ticketgames$tick = svs.ticketgames.ticketUtility.components,
  GameLauncherLeia = _svs$ticketgames$tick.GameLauncherLeia,
  GameWrapper = _svs$ticketgames$tick.GameWrapper,
  TopBar = _svs$ticketgames$tick.TopBar,
  LoaderTicket = _svs$ticketgames$tick.LoaderTicket,
  TicketIdPopper = _svs$ticketgames$tick.TicketIdPopper;
const _svs$ticketgames$tick2 = svs.ticketgames.ticketUtility.utils,
  resizeFromFullscreen = _svs$ticketgames$tick2.resizeFromFullscreen,
  resizeFromTicketInfo = _svs$ticketgames$tick2.resizeFromTicketInfo,
  useDefaultEventsLeiaFactory = _svs$ticketgames$tick2.useDefaultEventsLeiaFactory,
  useScratchDefaultEventsLeiaFactory = _svs$ticketgames$tick2.useScratchDefaultEventsLeiaFactory,
  showDialog = _svs$ticketgames$tick2.showDialog,
  tracking = _svs$ticketgames$tick2.tracking,
  showWonTicketWaitingDialog = _svs$ticketgames$tick2.showWonTicketWaitingDialog;
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState,
  useCallback = _React.useCallback,
  useReducer = _React.useReducer,
  useMemo = _React.useMemo;
const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_GAME_REF':
      return _objectSpread(_objectSpread({}, state), {}, {
        gameRef: action.payload
      });
    case 'SET_BET_ID':
      return _objectSpread(_objectSpread({}, state), {}, {
        betId: action.payload
      });
    default:
      return state;
  }
};
const GameLauncherWrapper = _ref => {
  var _ticketInfo$skins;
  let history = _ref.history,
    onClose = _ref.onClose,
    skinId = _ref.skinId,
    ticketInfo = _ref.ticketInfo,
    wagerId = _ref.wagerId,
    match = _ref.match,
    nextVoucher = _ref.nextVoucher,
    voucherCode = _ref.voucherCode,
    isPurchaseDisabled = _ref.isPurchaseDisabled,
    _ref$receiverSameAsBu = _ref.receiverSameAsBuyer,
    receiverSameAsBuyer = _ref$receiverSameAsBu === void 0 ? 0 : _ref$receiverSameAsBu,
    _ref$test = _ref.test,
    test = _ref$test === void 0 ? false : _ref$test;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    fullScreenMargin = _useState2[0],
    setFullScreenMargin = _useState2[1];
  const _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    wrapperSize = _useState4[0],
    setWrapperSize = _useState4[1];
  const isFullScreenGame = ticketInfo.width === 0 && ticketInfo.height === 0;
  const betId = wagerId && parseInt(wagerId, 10);
  const _useReducer = useReducer(reducer, {
      ticketInfo,
      betId,
      isFullScreenGame,
      voucherCode
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  const contextValue = useMemo(() => _objectSpread(_objectSpread({}, state), {}, {
    dispatch
  }), [state, dispatch]);
  useDefaultEventsLeiaFactory({
    ticketInfo,
    wagerId,
    onClose,
    voucherCode,
    isPurchaseDisabled
  });
  const _svs$ticketgames$tick3 = svs.ticketgames.ticketUtility.utils.useValidateVoucherCode({
      voucherCode,
      onClose
    }),
    isChecking = _svs$ticketgames$tick3.isChecking,
    invalidCode = _svs$ticketgames$tick3.invalidCode;
  const _useCustomEvents = useCustomEvents({
      ticketInfo,
      isFullScreenGame,
      onClose,
      history,
      match,
      nextVoucher,
      dispatch
    }),
    onPlayAgain = _useCustomEvents.onPlayAgain;
  const _useScratchDefaultEve = useScratchDefaultEventsLeiaFactory({
      ticketInfo,
      isFullScreenGame,
      onHasWonTicket: () => {
        setShouldShowPlayAgainFooter(true);
        gsap.delayedCall(0.8, () => {
          showWonTicketWaitingDialog();
        });
      },
      onClose,
      onPlayAgain,
      hasNextVoucher: Boolean(nextVoucher),
      test
    }),
    isLoading = _useScratchDefaultEve.isLoading,
    gameResult = _useScratchDefaultEve.gameResult,
    setShouldShowPlayAgainFooter = _useScratchDefaultEve.setShouldShowPlayAgainFooter,
    shouldShowPlayAgainFooter = _useScratchDefaultEve.shouldShowPlayAgainFooter,
    shouldShowBubbleWinMessage = _useScratchDefaultEve.shouldShowBubbleWinMessage,
    soundStatus = _useScratchDefaultEve.soundStatus,
    notifySoundStatus = _useScratchDefaultEve.notifySoundStatus;
  const onResizeFunc = isFullScreenGame ? resizeFromFullscreen : resizeFromTicketInfo;
  useEffect(() => {
    const init = async () => {
      if (voucherCode && !wagerId) {
        svs.ticket_gifts.logger.info("voucher redeem - receiverSameAsBuyer: ".concat(Boolean(receiverSameAsBuyer)));
      }
      svs.ticket_gifts.redeem.components.util.hideFooter();
      const product = ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.branding;
      const extraParams = {
        amount: ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.price,
        product,
        branding: product
      };
      if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
        svs.components.customer_login.login({
          returnNewCustomer: true,
          extraParams
        });
      } else {
        var _svs, _svs$setupExtraData;
        await ((_svs = svs) === null || _svs === void 0 || (_svs = _svs.accountservices) === null || _svs === void 0 || (_svs = _svs.onboardingHandler) === null || _svs === void 0 || (_svs$setupExtraData = _svs.setupExtraData) === null || _svs$setupExtraData === void 0 ? void 0 : _svs$setupExtraData.call(_svs, {
          extraData: extraParams
        }));
      }
    };
    init();
  }, []);
  const onResize = useCallback(container => {
    const size = onResizeFunc(container, ticketInfo);
    if (isFullScreenGame) {
      setFullScreenMargin(size === null || size === void 0 ? void 0 : size.isMinHeight);
    } else {
      setWrapperSize(size);
    }
  }, []);
  const bubbleWinOptions = _objectSpread({
    demo: false,
    product: ticketInfo.type
  }, gameResult);
  const topBarTrackingLabel = tracking.createTopBarTrackingLabel({
    location: 'lös-in-voucher',
    gameCode: ticketInfo.type
  });
  const wrapperStyles = isFullScreenGame && fullScreenMargin ? {
    padding: '24px'
  } : _objectSpread(_objectSpread({}, wrapperSize), {}, {
    margin: 'auto'
  });
  const gameSpecificParameters = {
    voucherId: voucherCode,
    skinId: skinId ? skinId : 1
  };
  if (isChecking || invalidCode) {
    return React.createElement("div", null);
  }
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "js-game-launcher-wrapper ".concat(gameResult ? 'game-complete ' : '').concat(isFullScreenGame ? '' : "padding-top-4")
  }, shouldShowBubbleWinMessage && !isFullScreenGame && React.createElement("div", {
    className: "qa-win-message-container game-header relative"
  }, React.createElement(BubbleWinMessage, {
    options: bubbleWinOptions
  })), React.createElement(GameWrapper, {
    className: "".concat(isFullScreenGame ? '' : 'ticket-shadow'),
    context: contextValue,
    styles: wrapperStyles
  }, React.createElement(TopBar, {
    isSoundOn: soundStatus,
    onClose: () => {
      var _gameResult$amount;
      showDialog({
        type: 'close',
        onClose,
        trackingData: {
          label: topBarTrackingLabel,
          value: (_gameResult$amount = gameResult === null || gameResult === void 0 ? void 0 : gameResult.amount) !== null && _gameResult$amount !== void 0 ? _gameResult$amount : -1
        }
      });
    },
    onSoundClick: () => {
      notifySoundStatus(!soundStatus);
    },
    trackingLabel: topBarTrackingLabel
  }), React.createElement(GameLauncherLeia, {
    className: "relative",
    gameSpecificParameters: gameSpecificParameters,
    onResize: onResize
  }, !isLoading && React.createElement(TicketIdPopper, null), isLoading && React.createElement(LoaderTicket, {
    image: !isFullScreenGame && ((_ticketInfo$skins = ticketInfo.skins[skinId - 1]) === null || _ticketInfo$skins === void 0 ? void 0 : _ticketInfo$skins.image)
  })))), shouldShowPlayAgainFooter && React.createElement(PlayFooter, {
    hasMoreVouchers: nextVoucher,
    onClick: onPlayAgain,
    receiverSameAsBuyer: receiverSameAsBuyer,
    ticketInfo: ticketInfo
  }));
};
setGlobal('svs.ticket_gifts.redeem.components.GameLauncherWrapper', GameLauncherWrapper);

 })(window);